import Card from "react-bootstrap/Card";
import Rating from "@mui/material/Rating";
import BestSeller from "../BestSeller/BestSeller";
import "./CardEle.css";
import { Link } from "react-router-dom";
import { ICourseDetails } from "../../utils/interface";
type CardProps = {
  courses: ICourseDetails;
};

function CardEle(props: CardProps) {
  let bestSeller;
  if (props.courses.isBestSeller) bestSeller = <BestSeller />;
  return (
    <Link to={`/coursedetails/${props.courses._id}`}>
      <div className="card-item modern-course-card">
        <img
          className="card-img"
          alt="course_description"
          src={props.courses.thumbnail}
        />
        <div className="card-content">
          <p className="fw-550 course-title">{props.courses.title}</p>
          <p className="course-author">{props.courses.author}</p>
          <div className="course-rating">
            {
              <Rating
                name="half-rating"
                defaultValue={props.courses.rating}
                precision={0.5}
                readOnly
              />
            }
          </div>
          <p className="fw-550 course-price">₹{props.courses.originalPrice}</p>
          {bestSeller}
        </div>
      </div>
    </Link>
  );
}

export default CardEle;
